export const getOptionLabel = (locale, group, value, fallback = value) =>
  locale?.options?.[group]?.[value] || fallback;

export const localizeOption = (item, locale, group) => {
  if (typeof item === "string") {
    return {
      text: getOptionLabel(locale, group, item, item),
      value: item
    };
  }

  return {
    ...item,
    text: getOptionLabel(locale, group, item.value, item.text || item.value)
  };
};

export const localizeOptions = (items, locale, group) =>
  items.map((item) => localizeOption(item, locale, group));
